/**
 * @generated SignedSource<<f806de2059e0ea9b3fff85fabe420f6e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AttributeTxnsInputObject = {
  name?: string | null | undefined;
  perspectiveId?: string | null | undefined;
  stakeholderId?: string | null | undefined;
  txnIds: ReadonlyArray<string>;
};
export type useTxnBulkActions_AttributeTxnsMutation$variables = {
  input: AttributeTxnsInputObject;
};
export type useTxnBulkActions_AttributeTxnsMutation$data = {
  readonly attributeTxns: {
    readonly conflictingRules: ReadonlyArray<{
      readonly caseSensitive: boolean;
      readonly direction: string;
      readonly id: string;
      readonly isCaptureRule: boolean;
      readonly matchField: string;
      readonly matchKind: string;
      readonly matchesCount: number;
      readonly regex: string;
      readonly stakeholder: {
        readonly id: string;
        readonly name: string;
      } | null | undefined;
    }>;
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
    readonly stakeholder: {
      readonly id: string;
      readonly name: string;
    } | null | undefined;
  } | null | undefined;
};
export type useTxnBulkActions_AttributeTxnsMutation = {
  response: useTxnBulkActions_AttributeTxnsMutation$data;
  variables: useTxnBulkActions_AttributeTxnsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "Stakeholder",
  "kind": "LinkedField",
  "name": "stakeholder",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "Rule",
  "kind": "LinkedField",
  "name": "conflictingRules",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "regex",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "matchKind",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "caseSensitive",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "direction",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "matchField",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isCaptureRule",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "matchesCount",
      "storageKey": null
    },
    (v3/*: any*/)
  ],
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useTxnBulkActions_AttributeTxnsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AttributeTxnsMutationPayload",
        "kind": "LinkedField",
        "name": "attributeTxns",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useTxnBulkActions_AttributeTxnsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AttributeTxnsMutationPayload",
        "kind": "LinkedField",
        "name": "attributeTxns",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v5/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "721383753381b1e5c6f4a47bd6cc40c0",
    "id": null,
    "metadata": {},
    "name": "useTxnBulkActions_AttributeTxnsMutation",
    "operationKind": "mutation",
    "text": "mutation useTxnBulkActions_AttributeTxnsMutation(\n  $input: AttributeTxnsInputObject!\n) {\n  attributeTxns(input: $input) {\n    stakeholder {\n      id\n      name\n    }\n    conflictingRules {\n      id\n      regex\n      matchKind\n      caseSensitive\n      direction\n      matchField\n      isCaptureRule\n      matchesCount\n      stakeholder {\n        id\n        name\n      }\n    }\n    errors {\n      message\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "da8bedee13a92dc4b4d9b28e41f1fcb8";

export default node;
